import { CircularProgress } from '@mui/material';

const SuspenseLoading = () => {
  return <CircularProgress />;
};

export default SuspenseLoading;
